/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Add_For_AreaInputs */

const vi_grower_area_camera_add_for_area = /** @type {(inputs: Grower_Area_Camera_Add_For_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm camera cho vùng này`)
};

/**

* @param {Grower_Area_Camera_Add_For_AreaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_add_for_area = /** @type {((inputs?: Grower_Area_Camera_Add_For_AreaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Add_For_AreaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_add_for_area(inputs)
});